// extracted by mini-css-extract-plugin
module.exports = {"auto_title":"auto_title-2IuO-gez"};